
export interface UnlocData<T> {
  loaded: boolean
  loading: boolean
  datas: T[]
  listeners: ((data: T[]) => void)[]
}

export class UnlocDataHelper {
  static callLoadingDataListeners<T>(helper: UnlocData<T>) {
    helper.loaded = true;
    helper.loading = false;
    for (const listener of helper.listeners) {
      listener(helper.datas)
    }
    helper.listeners = [];
  }
}

export class ExternalData<T> {
  loaded: boolean = false
  loading: boolean = false
  datas: T[] = []
  listeners: ((data: T[]) => void)[] = []

  finishedLoading(datas: T[]) {
    this.datas = datas;
    this.loaded = true;
    this.loading = false;
    for (const listener of this.listeners) {
      listener(datas)
    }
    this.listeners = [];
  }
}
